import e from "../managers/braze-instance.js";
import re from "./feed-provider-factory.js";
export function getCachedFeed() {
  if (e.X()) return re.rr().Li();
}
